import React from 'react';
import SvgIcon, {
 SvgIconProps,
} from '@mui/material/SvgIcon';

export default function ContinuousCareIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g
        fill="none"
        stroke="currentColor"
        strokeWidth={1.75}
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M4 12A8 8 0 0 1 18.93 8" />
        <path d="M19 4v4h-4" />
        <path d="M20 12A8 8 0 0 1 5.07 16" />
        <path d="M5 20v-4h4" />
        <path d="M12 15.18C9.91 13.88 8.83 12.66 8.83 11.36C8.83 10.43 9.55 9.78 10.42 9.78C11.14 9.78 11.71 10.21 12 10.79C12.29 10.21 12.86 9.78 13.58 9.78C14.45 9.78 15.17 10.43 15.17 11.36C15.17 12.66 14.09 13.88 12 15.18Z" />
      </g>
    </SvgIcon>
  );
}